export default __webpack_public_path__ + "b2a47cb0a7b49bd0538f0df19b1b1f45.jpg";